import { render } from "./MalaTowns.vue?vue&type=template&id=fb0b8d80&scoped=true"
import script from "./MalaTowns.vue?vue&type=script&lang=js"
export * from "./MalaTowns.vue?vue&type=script&lang=js"

import "./MalaTowns.vue?vue&type=style&index=0&id=fb0b8d80&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb0b8d80"]])

export default __exports__